import { useAuth } from 'oidc-react';
import { ComponentType } from 'react';
import { useCleanOidcQueryParams } from './useCleanOidcQueryParams.hook';

export const withCleanOidcQueryParams = <P,>(Component: ComponentType<P>) => {
  const Wrapped: React.FC<P> = props => {
    const { userData } = useAuth();

    useCleanOidcQueryParams(!!userData?.access_token);

    return <Component {...props} />;
  };

  Wrapped.displayName = `withCleanOidcQueryParams(${Component.displayName ?? Component.name ?? 'Component'})`;

  return Wrapped;
};
